import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import Hero from '@/pages/home/components/Hero';
import Ticker from '@/pages/home/components/Ticker';
import HotMelons from '@/pages/home/components/HotMelons';
import Psychology from '@/pages/home/components/Psychology';
import ColdFacts from '@/pages/home/components/ColdFacts';
import Jokes from '@/pages/home/components/Jokes';
import Memes from '@/pages/home/components/Memes';
import Guide from '@/pages/home/components/Guide';
import Categories from '@/pages/home/components/Categories';
import Faq from '@/pages/home/components/Faq';
import About from '@/pages/home/components/About';
import Subscribe from '@/pages/home/components/Subscribe';

export default function Home() {
  return (
    <div className="w-full bg-background-50">
      <SiteHeader />
      <main>
        <Hero />
        <Ticker />
        <HotMelons />
        <Psychology />
        <ColdFacts />
        <Jokes />
        <Memes />
        <Guide />
        <Categories />
        <Faq />
        <About />
        <Subscribe />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}